/**
 * Transforms a Unicode JavaScript (UTF-16) string to a Base64 UTF-8 string.
 */
export function base64EncodeUnicode(str: string): string {
  // Encodes a Unicode JavaScript string (UTF-16 -> UTF-8 -> base64).
  //
  // When base64-encoding a Unicode JavaScript string we cannot just `btoa(str)`
  // directly because the internal represention of `str` is UTF-16, but `btoa`
  // only works on "binary string" (a string in which each character is treated
  // as a byte of binary data; that is, each character must be in the range
  // 0...255).  Instead, this function converts the string from UTF-16 to a
  // series of UTF-8 bytes, and then calls `btoa` on the converted string.
  //
  // We don't use `btoa(unescape(encodeURIComponent(str)))` because it uses the
  // deprecated `unescape` function.

  return btoa(
    encodeURIComponent(str).replace(
      /%([0-9A-F]{2})/g,
      function (_match: string, p1: string) {
        return String.fromCharCode(parseInt(p1, 16));
      }
    )
  );
}

/**
 * Transforms a Base64 Unicode UTF-8 string to a JavaScript (UTF-16) string.
 */
export function base64DecodeUnicode(str: string): string {
  // Decodes a Unicode JavaScript string (base64 -> UTF-8 -> UTF-16).
  //
  // We don't use `decodeURIComponent(escape(atob(str)))` because it uses the
  // deprecated `escape` function.

  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c: string) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
}
